import { render, staticRenderFns } from "./ModalAppointment.vue?vue&type=template&id=64b01cc4&scoped=true&lang=pug"
import script from "./ModalAppointment.vue?vue&type=script&lang=js"
export * from "./ModalAppointment.vue?vue&type=script&lang=js"
import style0 from "./ModalAppointment.vue?vue&type=style&index=0&id=64b01cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b01cc4",
  null
  
)

export default component.exports